import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { usePharmacy } from '../context/PharmacyContext';
import { motion } from 'framer-motion';
import axios from 'axios';

function DrugInteractionChecker() {
  const { register, handleSubmit } = useForm();
  const { setInteractions } = usePharmacy();
  const [results, setResults] = useState([]);

  const onSubmit = async (data) => {
    // Replace with actual API call
    // const response = await axios.get(`api/drug-interaction?drugs=${data.drugs}`);
    const mockResponse = [{ drugs: data.drugs, interaction: 'None' }];
    setResults(mockResponse);
    setInteractions(mockResponse);
  };

  return (
    <motion.div initial={{ x: '-100vw' }} animate={{ x: 0 }} exit={{ x: '100vw' }}>
      <h2>Drug Interaction Checker</h2>
      <form onSubmit={handleSubmit(onSubmit)}>
        <input {...register('drugs')} placeholder="Enter Drugs" required />
        <button type="submit">Check Interaction</button>
      </form>
      <ul>
        {results.map((result, index) => (
          <li key={index}>{result.drugs}: {result.interaction}</li>
        ))}
      </ul>
    </motion.div>
  );
}

export default DrugInteractionChecker;
